var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H2c-1.1,0-2-.9-2-2V2C0,.9.9,0,2,0h6c1.1,0,2,.9,2,2v6c0,1.1-.9,2-2,2ZM2,2h0v6h6V2H2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,22H2c-1.1,0-2-.9-2-2v-6c0-1.1.9-2,2-2h6c1.1,0,2,.9,2,2v6c0,1.1-.9,2-2,2ZM2,14h0v6h6v-6H2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22h-6c-1.1,0-2-.9-2-2v-6c0-1.1.9-2,2-2h6c1.1,0,2,.9,2,2v6c0,1.1-.9,2-2,2ZM14,14h0v6h6v-6h-6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10h-6c-1.1,0-2-.9-2-2V2c0-1.1.9-2,2-2h6c1.1,0,2,.9,2,2v6c0,1.1-.9,2-2,2ZM14,2h0v6h6V2h-6Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack12);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-12.9a67d21f969710c5296a835d6db474c0.svg";
export { ForwardRef as ReactComponent };